/**
 * Firebase Storage configuration constants
 */
import type { StorageConfig, StoragePath } from './types';

export const STORAGE_CONFIG: StorageConfig = {
  maxFileSizeBytes: 5 * 1024 * 1024, // 5MB
  allowedMimeTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  supportedExtensions: ['.jpg', '.jpeg', '.png', '.webp'],
};

export const STORAGE_PATHS: StoragePath = {
  posters: (groupId: string, meetingId: string, fileName: string) =>
    `posters/meetings/${groupId}/${meetingId}/${fileName}`,

  groupPosters: (groupId: string, fileName: string) =>
    `posters/groups/${groupId}/${fileName}`,

  tempPosters: (userId: string, fileName: string) => `temp/posters/${userId}/${fileName}`,

  defaultAssets: (fileName: string) => `assets/posters/defaults/${fileName}`,
};

// Cache control headers for different asset types
export const CACHE_HEADERS = {
  posters: 'public, max-age=86400, s-maxage=31536000', // 1 day browser, 1 year CDN
  defaults: 'public, max-age=31536000, s-maxage=31536000', // 1 year both
  temp: 'private, max-age=3600', // 1 hour private cache
} as const;

// Image compression and optimization settings
export const IMAGE_OPTIMIZATION = {
  poster: {
    maxWidth: 1200,
    maxHeight: 675, // 16:9 aspect ratio
    quality: 0.85,
    format: 'webp' as const,
  },
  thumbnail: {
    maxWidth: 300,
    maxHeight: 169,
    quality: 0.8,
    format: 'webp' as const,
  },
} as const;

// Default poster categories and metadata
export const DEFAULT_POSTER_CATEGORIES = [
  'tech',
  'community',
  'workshop',
  'networking',
  'general',
] as const;

export type DefaultPosterCategory = (typeof DEFAULT_POSTER_CATEGORIES)[number];
